import React from "react";
import { SignIn, SignUp } from "@clerk/react";
import { Logo } from "@/components/site/Logo";

function Shell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-ink font-body text-mist">
      <div className="px-5 py-4 md:px-10"><Logo /></div>
      <div className="flex flex-1 items-center justify-center px-4 py-10" data-testid="auth-shell">{children}</div>
    </div>
  );
}

export const SignInPage = () => (
  <Shell><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp fallbackRedirectUrl="/dashboard" /></Shell>
);

export const SignUpPage = () => (
  <Shell><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/dashboard" /></Shell>
);
